/**
 * @param {string} token
 * @returns {{payload: { exp: number, userId: number, roleId: number }, signature: string, header: object}}
 */
export function decodeJwtToken<T>(token: string) {
    const [header, payload, signature] = token.split('.');

    return {
        header: JSON.parse(atob(header)),
        payload: JSON.parse(atob(payload)) as T,
        signature,
    };
}

export function isTokenValid(exp: number): boolean {
    return Date.now() < exp * 1000;
}
